import presentationDefaultState from './presentation'
import audienceDefaultState from './audience'
import slideDefaultState from './slide'
import attendedPresentation from './attendedPresentation'
import commonDefaultState from './common'

export default {
  ...presentationDefaultState,
  ...audienceDefaultState,
  ...slideDefaultState,
  ...attendedPresentation,
  ...commonDefaultState,
}
